{/*import React, { useEffect, useState } from 'react';
import { show_friend_list } from '../../api';

import { photoUrl } from '../../constants';
import { Link } from 'react-router-dom';*/}

const Friends = () => {
  {/*const [result, setResult] = useState();

  useEffect(() => {
    show_friend_list().then((res) => {
      setResult(res.data);
    })

  }, []);

  console.log(result);*/}


  return (
    {/*<div className="w-full home-container">
      <div className="w-full">
      {result?.length > 0 && (
        <>
          {result?.map((friend) => (
            <div className="flex flex-col items-center relative border h-full w-32">
                <Link to={`/profile/${friend?.id}`}>
                  <img src={`${photoUrl}/${friend?.profile_img}`} className="w-24 h-24 rounded-full object-cover" />
                </Link>
                
              <div className="mt-1 flex flex-col w-full">
                <span className="font-semibold text-md text-center">{friend?.firstname} {friend?.lastname}</span>
                
                <button className="border p-2 rounded-lg bg-blue-500 w-full text-white text-md font-semibold">
                   Unfriend
                </button>
              </div>
              
            </div>
          ))}
        </>
      )}
      </div>
    </div>*/}
  )
}

export default Friends